import React from 'react'
import { connect } from 'react-redux'
import { Cart, actions } from './.'
import { isRedeemPointsMoreOthers } from 'Catalog/ducks'

const mapStateToProps = ({
  onlyCash,
  address,
  cart,
  catalog: {
    currencyConfiguration: { pointsName, decimalPlaces },
    redeemType
  },
  cardBrands,
  participant,
  stores: { ecommerce, vouchers, services }
}) => ({
  ...cart,
  address,
  pointsName,
  decimalPlaces,
  isRedeemPointsMoreOthers: isRedeemPointsMoreOthers(redeemType),
  cardBrands,
  participant,
  stores: [...ecommerce, ...vouchers, ...services],
  onlyCash
})

const mapDispatchToProps = dispatch => ({
  fetchCart: () => dispatch(actions.loadCart()),
  fetchShipping: zipCode => {
    dispatch(actions.fetchShipping(zipCode))
  },
  clearConfirmedOrderData: () => {
    dispatch({ type: 'CLEAR_CONFIRMED_ORDER_DATA' })
  },
  resetShipping: () => {
    dispatch(actions.resetShipping())
  },
  updateShippingAddress: data => dispatch(actions.updateShippingAddress(data)),
  removeItem: sku => dispatch(actions.removeItem(sku)),
  updateItem: data => dispatch(actions.updateItem(data))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(props => <Cart {...props} />)



// WEBPACK FOOTER //
// ./src/features/Cart/CartContainer.js